import React, { useState } from 'react';
import styles from './form.module.scss';

export type Invalid = 'none' | 'block';

export type BorderColors = null | 'var(--primary-red)';

interface InputProps {
    id: string;
    label: string;
    placeholder: string;
    type: 'text' | 'email';
    value: string;
    setValue: Function;
    invalid: Invalid;
    toggleInvalid: Function;
    invalidBorder: BorderColors;
    toggleBorderColor: Function;
    extraClasses?: string;
}

const InputComponent = ({
    id,
    label,
    placeholder,
    type,
    value,
    setValue,
    invalid,
    toggleInvalid,
    invalidBorder,
    toggleBorderColor,
    extraClasses = '',
}: InputProps) => {
    const [visibleNameLabel, toggleVisibleLabel] = useState<Invalid>('none');

    return (
        <div className={`${styles.labelContainer} ${extraClasses}`}>
            <label htmlFor={id} className={styles.label} style={{ display: visibleNameLabel }}>
                {label}
                <span style={{ color: 'var(--primary-red)' }}>*</span>
            </label>
            <input
                id={id}
                type={type}
                style={{ borderBottomColor: invalidBorder }}
                className={styles.input}
                placeholder={`${placeholder}*`}
                value={value}
                aria-label={label}
                onChange={(event) => {
                    setValue(event.target.value);
                    if (event.target.value.length > 0) {
                        toggleBorderColor(null);
                        toggleInvalid('none');
                        toggleVisibleLabel('block');
                    } else {
                        toggleVisibleLabel('none');
                    }
                }}
            />
            <span className={styles.invalid} style={{ display: invalid }}>
                Please fill out this field
            </span>
        </div>
    );
};

export default InputComponent;
